<template>
  <div
    class="modal bg-[rgba(0, 0, 0, 1)] fade py-1 z-[111111111]"
    id="mod-process"
    role="dialog"
  >
    <div class="modal-dialog mx-auto">
      <div class="modal-content p-[24px] bg-[#f8f8f8]">
        <div class="modal-body m-0 p-0">
          <p class="text-[14px] leading-[20px] font-normal text-[#353535]">
            You are about to
            <span class="text-uppercase">process</span> a purchase order with
            Purchase Order Number {{ order.orderNumber }}
          </p>
        </div>
        <div class="flex items-center gap-[8px] mt-[16px]">
          <button
            class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            :disabled="isBusyModal"
            @click.prevent="onSubmitClick"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessStatusModal",
  props: ["order"],

  data() {
    return {
      isBusyModal: false,
    };
  },

  methods: {
    async onSubmitClick() {
      this.isBusyModal = true;
      try {
        const response = await this.$http.put(
          `/PurchaseOrders/manufacturer/updateStatus/${this.order.id}`
        );

        if (response) {
          // eslint-disable-next-line no-undef
          $("#mod-process").modal("hide");
          this.isBusyModal = false;
          this.$emit("onComplete");
        }
      } catch (error) {
        this.isBusyModal = false;
      }
    },
  },
};
</script>

<style></style>
